var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.802246,
    y: 0.500977,
    width: 6.61032,
    height: 24.5904,
    fill: "#4F46E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.802246,
    y: 0.500977,
    width: 6.61032,
    height: 5.55267,
    fill: "#B8B5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4841 25.0912C29.3475 25.0912 34.9115 19.5272 34.9115 12.6637C34.9115 5.80027 29.3475 0.236328 22.4841 0.236328C15.6206 0.236328 10.0566 5.80027 10.0566 12.6637C10.0566 19.5272 15.6206 25.0912 22.4841 25.0912ZM22.4841 18.4809C25.6968 18.4809 28.3012 15.8765 28.3012 12.6638C28.3012 9.45114 25.6968 6.84674 22.4841 6.84674C19.2714 6.84674 16.667 9.45114 16.667 12.6638C16.667 15.8765 19.2714 18.4809 22.4841 18.4809Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.592 18.3754L23.3638 18.6036L30.5235 25.7634L35.1977 21.0892L28.1396 14.031C27.6095 16.2312 25.829 17.944 23.592 18.3754Z",
    fill: "#B8B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.35ca2010b98a847732fde953a1b7201c.svg";
export { ForwardRef as ReactComponent };